import React from 'react'
import NavBar from '../Components/NavBar'
import Header from '../Components/Header'
import PartAboutUs from '../Components/AboutUs/PartAboutUs'
import PartOurTeam from '../Components/AboutUs/PartOurTeam'
import PartLoyalty from '../Components/M2O/PartLoyalty'
import PartM20 from '../Components/M2O/PartM20'
import PartNaturalSpending from '../Components/M2O/PartNaturalSpending'
import PartPartner from '../Components/Partner/PartPartner'
import PartBenefit from '../Components/Partner/PartBenefit'
import PartTeam from '../Components/Team/PartTeam'
import PartTeam2 from '../Components/Team/PartTeam2'
import PartGallery from '../Components/Partner/PartGallery'
import PartContactUsFP from '../Components/FonePlus/PartContactUsFP'
import PartFonePlus from '../Components/FonePlus/PartFonePlus'
import PartContactUs from '../Components/ContactUs/PartContactUs'
import Footer from '../Components/Footer'
import { useEffect } from 'react';

function FoneApp() {

  useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <div>
      <NavBar/>
      <Header/>
      <PartAboutUs/>
      <PartOurTeam/>
      <PartLoyalty/>
      <PartM20/>
      <PartNaturalSpending/>
      <PartPartner/>
      <PartGallery/>
      <PartBenefit/>
      <PartFonePlus/>
      <PartContactUsFP/>
      <PartTeam/>
      <PartTeam2/>
      <PartContactUs/>
      <Footer/>
    </div>
  )
}

export default FoneApp
